import { isPlatformBrowser } from "@angular/common";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { inject, Injectable, PLATFORM_ID } from "@angular/core";
import { environment } from "../../environments/environment";
import { Order } from "@models/order";
import { Page } from "@models/page";
import { SellerOrder, SellerOrdersFilters } from "@models/seller-order";
import { Observable } from "rxjs";
import { LocalStorageService } from "./local-storage.service";

@Injectable({
  providedIn: "root",
})
export class OrdersService {
  private readonly apiUrl = environment.API_BACKEND;
  private readonly baseUrl = `${environment.API_BACKEND}/orders`;
  private readonly platformId = inject(PLATFORM_ID);

  constructor(
    private readonly http: HttpClient,
    private readonly localStorageService: LocalStorageService,
  ) {}

  getOrderById(orderId: number) {
    return this.http.get<Order>(`${this.baseUrl}/${orderId}`);
  }

  getSellerOrders(filters: SellerOrdersFilters): Observable<Page<SellerOrder>> {
    let params = new HttpParams()
      .set("page", filters.page ?? 1)
      .set("per_page", filters.per_page ?? 10)
      .set("include_qr", filters.include_qr ? "true" : "false");

    if (filters.event_id) {
      params = params.set("event_id", filters.event_id);
    }

    if (filters.initial_date) {
      params = params.set("start_date", filters.initial_date);
    }

    if (filters.final_date) {
      params = params.set("end_date", filters.final_date);
    }

    if (filters.order_number?.trim()) {
      params = params.set("order_id", filters.order_number.trim());
    }

    return this.http.get<Page<SellerOrder>>(`${this.apiUrl}/seller/my_orders`, {
      headers: this.getHttpHeaders(),
      params,
    });
  }

  private getToken(): string | null {
    if (isPlatformBrowser(this.platformId)) {
      return this.localStorageService.getItem("auth-token");
    }
    return null;
  }

  private getHttpHeaders(): HttpHeaders {
    const token = this.getToken();
    return new HttpHeaders({
      Authorization: `Bearer ${token}`,
    });
  }
}
